import { getTccEligibility, getCustomerRelatedAccount, eSimValidation, tccCemBffSendOtp, cemSimSwapValidateOtp, cemSimSwapResendOtp } from "../api/api";
import { SequenceManagerAction } from '../actions/SequenceManagerAction';


const TCCEligibilityCheckAction = {
  TCC_ELIGIBILITY_CHECK_SUCCESS : "TCC_ELIGIBILITY_CHECK_SUCCESS",
  TCC_ELIGIBILITY_CHECK_FAILURE : 'TCC_ELIGIBILITY_CHECK_FAILURE',
  CUSTOMER_RELATED_ACCOUNT_SUCCESS : "CUSTOMER_RELATED_ACCOUNT_SUCCESS",
  CUSTOMER_RELATED_ACCOUNT_FAILURE : 'CUSTOMER_RELATED_ACCOUNT_FAILURE',
  STORE_CUSTOMER_DETAILS : 'STORE_CUSTOMER_DETAILS',
  ESIM_VALIDATION_SUCCESS : 'ESIM_VALIDATION_SUCCESS',
  ESIM_VALIDATION_FAILURE : 'ESIM_VALIDATION_FAILURE',
  TCC_ELIGIBILITY_CEM_OTP_INITIATE_SUCCESS : 'TCC_ELIGIBILITY_CEM_OTP_INITIATE_SUCCESS',
  TCC_ELIGIBILITY_CEM_OTP_VALIDATE_SUCCESS : 'TCC_ELIGIBILITY_CEM_OTP_VALIDATE_SUCCESS',
  TCC_ELIGIBILITY_CEM_OTP_RSEND_SUCCESS : 'TCC_ELIGIBILITY_CEM_OTP_RSEND_SUCCESS',
} as const;

const win: any = window
const retryCount = win['AllowedAPIRetryCount'];

let performCounter = 0;
let eligibilityCounter = 0;

const performTCCEligibilityCheck = (personId: any, nationality: any, nationalityName: any, nationalityFieldName: any, requestType: any, contactPhone: any, isCustomerConsent: any) => {
  return function (dispatch: any) {
    getTccEligibility(personId, nationality, requestType, isCustomerConsent)
      .then((response) => {
        dispatch({
          type: TCCEligibilityCheckAction.TCC_ELIGIBILITY_CHECK_SUCCESS,
          payload: {
            response: response,
            personId: personId,
            nationality: nationality,
            nationalityName: nationalityName,
            nationalityFieldName: nationalityFieldName,
            idType: personId.charAt(0),
            contactPhone: contactPhone,
            customerConsent: isCustomerConsent
          }
        });
      })
      .catch((error) => {
        //Display error
        if (error?.response?.status) {
          dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
        } else {
          ++eligibilityCounter
          if (eligibilityCounter < retryCount) {
            const objData = JSON.parse(error?.config?.data);
            const { personId, nationality, requestType, customerConsent } = objData;
            dispatch(getTccEligibility(personId, nationality, requestType, customerConsent === 'true' ? true : false));
          } else {
            dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
          }
        }
      })
  }
}

const performGetCustomerRelatedAccount = (personId: any) => {
  return function (dispatch: any) {
    getCustomerRelatedAccount(personId)
      .then((response) => {
        dispatch({ type: TCCEligibilityCheckAction.CUSTOMER_RELATED_ACCOUNT_SUCCESS, payload: { response: response.data } });
      })
      .catch((error) => {
        //Display error
        if (error?.response?.status) {
          dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
        } else {
          ++performCounter
          if (performCounter < retryCount) {
            const url = error?.config?.url;
            const personId = url.split("?")[1].split('&')[0].split('=')[1];

            dispatch(performGetCustomerRelatedAccount(personId));
          } else {
            dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
          }
        }
      })
  }
}

const storeCustomerDetails = (customerRelatedAccountResponse: any, offerContainerId: any, otpVal: any, newStackVal: any) => {
  return function (dispatch: any) {
    dispatch({ type: TCCEligibilityCheckAction.STORE_CUSTOMER_DETAILS, payload: { customerRelatedAccountResponse: customerRelatedAccountResponse, offerContainerId: offerContainerId, otpVal: otpVal, newStackVal: newStackVal } });
    dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['TCCEligibilityCheck'] });
  }
}

const eSimValidationAPI = (IDNumber: any, journeyName: any) => {
  return function (dispatch: any) {
    eSimValidation(IDNumber, journeyName).then((response) => {
      dispatch({ type: TCCEligibilityCheckAction.ESIM_VALIDATION_SUCCESS, payload: { response: response } });
    })
      .catch((error) => {
        //Display error
        dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
      })
  }
}

const eligibilitySendOtp = (number: any, idNumber: any, lang: any, nationality: any) => {
  return function (dispatch: any) {
    tccCemBffSendOtp(number, idNumber, lang, nationality)
      .then((response) => {
        dispatch({ type: TCCEligibilityCheckAction.TCC_ELIGIBILITY_CEM_OTP_INITIATE_SUCCESS, payload: response });
      })
      .catch((error) => {
        //Display error
        if (error?.response) {
          dispatch({ type: TCCEligibilityCheckAction.TCC_ELIGIBILITY_CEM_OTP_INITIATE_SUCCESS, payload: error.response });
        } else {
          dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
        }
      })
  }
}

const eligibilityValidateOtp = (otp: any, refId: any, clientId: any, ClientSecret: any) => {
  return function (dispatch: any) {
    cemSimSwapValidateOtp(otp, refId, clientId, ClientSecret)
      .then((response) => {
        dispatch({ type: TCCEligibilityCheckAction.TCC_ELIGIBILITY_CEM_OTP_VALIDATE_SUCCESS, payload: response });
      })
      .catch((err) => {
        //Display error
        const config = Object.assign(err?.config, { serviceName: 'validateLoginOTP' });
        const error = { ...err, config };

        if (error?.response) {
          dispatch({ type: TCCEligibilityCheckAction.TCC_ELIGIBILITY_CEM_OTP_VALIDATE_SUCCESS, payload: error.response });
        } else {
          dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
        }
      })
  }
}

const eligibilityResendOtp = (refId: any, mode: any) => {
  return function (dispatch: any) {
    cemSimSwapResendOtp(refId, mode)
      .then((response) => {
        dispatch({ type: TCCEligibilityCheckAction.TCC_ELIGIBILITY_CEM_OTP_RSEND_SUCCESS, payload: response });
      })
      .catch((err) => {
        //Display error
        const config = Object.assign(err?.config, { serviceName: 'resendCEMOTP' });
        const error = { ...err, config };

        if (error?.response) {
          dispatch({ type: TCCEligibilityCheckAction.TCC_ELIGIBILITY_CEM_OTP_RSEND_SUCCESS, payload: error?.response });
        } else {
          dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: { ...error, config } });
        }
      })
  }
}

export { TCCEligibilityCheckAction, performTCCEligibilityCheck, performGetCustomerRelatedAccount, storeCustomerDetails, eSimValidationAPI, eligibilitySendOtp, eligibilityValidateOtp, eligibilityResendOtp };